import React, { Component }  from 'react';
import {connect} from 'react-redux';
import FontIcon from 'material-ui/FontIcon';
import {BottomNavigation, BottomNavigationItem} from 'material-ui/BottomNavigation';
import Paper from 'material-ui/Paper';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ImageVideoPicker from '../image-video-picker'
import AddToHome from '../AddToHome';
import CircularProgress from 'material-ui/CircularProgress';
import {blue700} from 'material-ui/styles/colors';

const imageIcon = <FontIcon className="material-icons">image</FontIcon>;
const addIcon = <FontIcon className="material-icons">add</FontIcon>;
const draftIcon = <FontIcon className="material-icons">note</FontIcon>;

const style = {
    mainLayout:{
        bottom: 0,
        zIndex: 10,
        width: '100vw',
        position: 'fixed'
    },
    cameraButton: {
        transform: 'translateY(-50%)',
        maxWidth: 56
    }
};

const loaderStyle = {
    display: 'inline-block',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1
};

class MainLayout extends Component {

    select = (index) => this.setState({selectedIndex: index});

    componentWillMount() {
        const index = /uploads$/.test(this.props.router.location.pathname) ? 2 : 0;
        this.select(index);
    }

    componentWillReceiveProps() {
        const index = /uploads$/.test(this.props.router.location.pathname) ? 2 : 0;
        this.select(index);
    }
    render() {
        return (
            <div id="mainLayout">
                {this.props.children}
                <AddToHome/>
                <Paper zDepth={1} style={style.mainLayout}>
                    <BottomNavigation selectedIndex={this.state.selectedIndex}>
                        <BottomNavigationItem
                            label="My Uploads"
                            icon={imageIcon}
                            onTouchTap={() => {
                                this.props.router.push('/');
                            }
                            }/>
                        <FloatingActionButton style={style.cameraButton}>{addIcon}
                            <ImageVideoPicker/>
                            {this.props.showLoader && <CircularProgress size={56} style={loaderStyle} color={blue700}/>}
                        </FloatingActionButton>
                        <BottomNavigationItem
                            label="In Progress"
                            icon={draftIcon}
                            onTouchTap={() => {
                                this.props.router.push('/uploads');
                            }}/>
                    </BottomNavigation>
                </Paper>
            </div>
        );
    }
}

const mapStateToProps = function(store) {
    return {
        showLoader: store.ui.showInfiniteScrollLoader
    };
};


export default connect(mapStateToProps)(MainLayout);
